import React from "react";
const FullEditIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    height="1em"
    width="1em"
    viewBox="0 0 25 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.3846 4.9642L22.7732 6.57562C22.6089 6.7399 22.3432 6.7399 22.1789 6.57562L18.299 2.69564C18.1347 2.53135 18.1347 2.2657 18.299 2.10141L19.9104 0.489996C20.564 -0.163658 21.6267 -0.163658 22.2838 0.489996L24.3846 2.59078C25.0417 3.24443 25.0417 4.30705 24.3846 4.9642ZM16.9148 3.48562L7.73564 12.6647L6.9946 16.9117C6.89323 17.485 7.39308 17.9813 7.96634 17.8835L12.2133 17.1389L21.3925 7.95982C21.5567 7.79554 21.5567 7.52988 21.3925 7.36559L17.5125 3.48562C17.3447 3.32133 17.079 3.32133 16.9148 3.48562V3.48562ZM11.3185 11.8782C11.1262 11.686 11.1262 11.3784 11.3185 11.1861L16.7015 5.80312C16.8938 5.61087 17.2014 5.61087 17.3936 5.80312C17.5859 5.99537 17.5859 6.30297 17.3936 6.49522L12.0106 11.8782C11.8184 12.0705 11.5108 12.0705 11.3185 11.8782V11.8782ZM10.0566 14.8179H11.7345V16.0868L9.47988 16.4818L8.39279 15.3947L8.78778 13.1401H10.0566V14.8179Z"
      fill="white"
    />
    <path
      d="M16.6258 14.8745V19.2496H2.8731V5.49688H12.7492C12.8868 5.49688 13.0157 5.44101 13.1145 5.34646L14.8336 3.62737C15.1603 3.30074 14.9282 2.74634 14.4683 2.74634H2.18546C1.04657 2.74634 0.122559 3.67035 0.122559 4.80924V19.9372C0.122559 21.0761 1.04657 22.0001 2.18546 22.0001H17.3134C18.4523 22.0001 19.3763 21.0761 19.3763 19.9372V13.1554C19.3763 12.6955 18.8219 12.4678 18.4953 12.7901L16.7762 14.5092C16.6817 14.608 16.6258 14.737 16.6258 14.8745Z"
      fill="white"
    />
  </svg>
);
export default FullEditIcon;
